import { AxiosError } from "axios";
import { all, call, put, takeLatest } from "redux-saga/effects";
import {
  ICourseMaterialPagePayloadValues,
  ISCOListByCourseIdRequest,
} from "utils/interfaces/course";
import {
  addCourseFailure,
  addCourseSuccess,
  deleteCourseFailure,
  deleteCourseSuccess,
  editCourseFailure,
  editCourseSuccess,
  courseListFailure,
  courseListSuccess,
  courseByIdSuccess,
  courseByIdFailure,
  courseMaterialListSuccess,
  courseMaterialListFailure,
  addCourseMaterialSuccess,
  addCourseMaterialFailure,
  editCourseMaterialSuccess,
  editCourseMaterialFailure,
  courseMaterialByIdSuccess,
  courseMaterialByIdFailure,
  deleteCourseMaterialSuccess,
  deleteCourseMaterialFailure,
  getSCOListByCourseIdSuccess,
  getSCOListByCourseIdFailure,
  pendingCourseEnrollmentEducatorsFailure,
  pendingCourseEnrollmentEducatorsSuccess,
} from "./actions";
import {
  COURSE_LIST_REQUEST,
  ADD_COURSE_REQUEST,
  EDIT_COURSE_REQUEST,
  DELETE_COURSE_REQUEST,
  COURSE_BY_ID_REQUEST,
  COURSE_MATERIAL_LIST_REQUEST,
  ADD_COURSE_MATERIAL_REQUEST,
  EDIT_COURSE_MATERIAL_REQUEST,
  COURSE_MATERIAL_BY_ID_REQUEST,
  DELETE_COURSE_MATERIAL_REQUEST,
  GET_SCO_LIST_BY_COURSE_ID_REQUEST,
  PENDING_COURSE_ENROLLMENT_EDUCATORS_REQUEST,
} from "./actionTypes";
import courseService from "./service";
import {
  AddEditCourseResponse,
  DeleteCourseResponse,
  CourseListResponse,
  CourseByIdResponse,
  CourseMaterialListResponse,
  AddEditCourseMaterialResponse,
  CourseMaterialByIdResponse,
  DeleteCourseMaterialResponse,
  SCOListByCourseIdResponse,
  CourseMaterialListRequest,
  AddCourseMaterialRequest,
  DeleteCourseMaterialRequest,
  CourseMaterialByIdRequest,
  EditCourseMaterialRequest,
  GetSCOListByCourseIdRequest,
  PendingCourseEnrollmentEducatorsResponse,
  PendingCourseEnrollmentEducatorsRequest,
} from "./types";

function* courseListSaga(action: any) {
  try {
    const payload: any = {
      sortColumn: action.payload.values.sortColumn,
      sortBy: action.payload.values.sortBy,
      pageNo: action.payload.values.pageNo,
      pageSize: action.payload.values.pageSize,
      name: action.payload.values.name,
    };
    if (action.payload.values.courseNo) {
      payload.courseNo = action.payload.values.courseNo;
    }
    if (action.payload.values.stream) {
      payload.stream = action.payload.values.stream;
    }

    const response: CourseListResponse = yield call(
      courseService.getCourseList,
      payload
    );

    const paginationDetails = {
      nextPage: response.item.nextPage,
      prevPage: response.item.prevPage,
      totalCount: response.item.totalRecordCount,
      totalPages: response.item.pageCount,
    };

    yield put(
      courseListSuccess({
        courseList: response.item.records,
        courseListPagination: paginationDetails,
      })
    );
    action.payload.callback({
      courseList: response.item.records,
      courseListPagination: paginationDetails,
    });
  } catch (e: any) {
    yield put(
      courseListFailure({
        error: e.message,
      })
    );
  }
}

function* addCourseSaga(action: any) {
  try {
    const response: AddEditCourseResponse = yield call(
      courseService.addCourse,
      {
        name: action.payload.values.name,
        courseNo: action.payload.values.courseNo,
        stream: action.payload.values.stream,
        previousName: action.payload.values.previousName,
        skills: action.payload.values.skills,
        knowledge: action.payload.values.knowledge,
        attitudes: action.payload.values.attitudes,
        courseAvailableInThisTerm:
          action.payload.values.courseAvailableInThisTerm,
        noOfSession: action.payload.values.noOfSession,
        lengthOfSingleSession: action.payload.values.lengthOfSingleSession,
        description: action.payload.values.description,
        isRecommendedForEducator:
          action.payload.values.isRecommendedForEducator,
        recommendedTo: action.payload.values.recommendedTo,
      }
    );

    yield put(
      addCourseSuccess({
        success: response.isSuccessStatusCode,
        message: response.message,
        courseId: response.item.id,
      })
    );
    action.payload.callback({
      success: response.isSuccessStatusCode,
      message: response.message,
      courseId: response.item.id,
    });
  } catch (e: any) {
    yield put(
      addCourseFailure({
        error: e.message,
      })
    );
  }
}

function* editCourseSaga(action: any) {
  try {
    const response: AddEditCourseResponse = yield call(
      courseService.editCourse,
      {
        id: action.payload.values.id,
        name: action.payload.values.name,
        courseNo: action.payload.values.courseNo,
        stream: action.payload.values.stream,
        previousName: action.payload.values.previousName,
        skills: action.payload.values.skills,
        knowledge: action.payload.values.knowledge,
        attitudes: action.payload.values.attitudes,
        courseAvailableInThisTerm:
          action.payload.values.courseAvailableInThisTerm,
        noOfSession: action.payload.values.noOfSession,
        lengthOfSingleSession: action.payload.values.lengthOfSingleSession,
        description: action.payload.values.description,
        isRecommendedForEducator:
          action.payload.values.isRecommendedForEducator,
        recommendedTo: action.payload.values.recommendedTo,
      }
    );

    yield put(
      editCourseSuccess({
        success: response.isSuccessStatusCode,
        message: response.message,
      })
    );
    action.payload.callback({
      success: response.isSuccessStatusCode,
      message: response.message,
    });
  } catch (e: any) {
    yield put(
      editCourseFailure({
        error: e.message,
      })
    );
  }
}

function* deleteCourseSaga(action: any) {
  try {
    const response: DeleteCourseResponse = yield call(
      courseService.deleteCourse,
      {
        id: action.payload.values.id,
      }
    );

    yield put(
      deleteCourseSuccess({
        success: response.isSuccessStatusCode,
      })
    );
    action.payload.callback({
      success: response.isSuccessStatusCode,
    });
  } catch (e: any) {
    yield put(
      deleteCourseFailure({
        error: e.message,
      })
    );
  }
}

function* courseByIdSaga(action: any) {
  try {
    const response: CourseByIdResponse = yield call(
      courseService.getCourseById,
      {
        id: action.payload.values.id,
      }
    );

    yield put(
      courseByIdSuccess({
        courseDetails: response.item,
      })
    );
    action.payload.callback({
      courseDetails: response.item,
    });
  } catch (e: any) {
    yield put(
      courseByIdFailure({
        error: e.message,
      })
    );
  }
}

function* courseMaterialListSaga(action: CourseMaterialListRequest) {
  try {
    const payload: ICourseMaterialPagePayloadValues = {
      pageNo: action.payload.values.pageNo,
      pageSize: action.payload.values.pageSize,
      courseId: action.payload.values.courseId,
    };
    const response: CourseMaterialListResponse = yield call(
      courseService.getCourseMaterialList,
      payload
    );
    const paginationDetails = {
      nextPage: response.item.nextPage,
      prevPage: response.item.prevPage,
      totalCount: response.item.totalRecordCount,
      totalPages: response.item.pageCount,
    };
    yield put(
      courseMaterialListSuccess({
        groupedCourseMaterialList: response.item.groupedRecords,
        courseMaterialListPagination: paginationDetails,
      })
    );
    action.payload.callback({
      groupedCourseMaterialList: response.item.groupedRecords,
      courseMaterialListPagination: paginationDetails,
    });
  } catch (e) {
    yield put(
      courseMaterialListFailure({
        error: (e as AxiosError).message,
      })
    );
  }
}

function* addCourseMaterialSaga(action: AddCourseMaterialRequest) {
  try {
    const response: AddEditCourseMaterialResponse = yield call(
      courseService.addCourseMaterial,
      {
        id: action.payload.values.id,
        courseId: action.payload.values.courseId,
        name: action.payload.values.name,
        type: action.payload.values.type,
        link: action.payload.values.link,
        description: action.payload.values.description,
        document: action.payload.values.document,
      }
    );

    yield put(
      addCourseMaterialSuccess({
        success: response.isSuccessStatusCode,
        message: response.message,
      })
    );
    action.payload.callback({
      success: response.isSuccessStatusCode,
      message: response.message,
    });
  } catch (e) {
    yield put(
      addCourseMaterialFailure({
        error: (e as AxiosError).message,
      })
    );
  }
}
function* editCourseMaterialSaga(action: EditCourseMaterialRequest) {
  try {
    const response: AddEditCourseMaterialResponse = yield call(
      courseService.editCourseMaterial,
      {
        id: action.payload.values.id,
        name: action.payload.values.name,
        type: action.payload.values.type,
        description: action.payload.values.description,
        link: action.payload.values.link,
        courseId: action.payload.values.courseId,
        document: action.payload.values.document,
        fileName: action.payload.values.fileName,
      }
    );

    yield put(
      editCourseMaterialSuccess({
        success: response.isSuccessStatusCode,
        message: response.message,
      })
    );
    action.payload.callback({
      success: response.isSuccessStatusCode,
      message: response.message,
    });
  } catch (e) {
    yield put(
      editCourseMaterialFailure({
        error: (e as AxiosError).message,
      })
    );
  }
}

function* courseMaterialByIdSaga(action: CourseMaterialByIdRequest) {
  try {
    const response: CourseMaterialByIdResponse = yield call(
      courseService.getCourseMaterialById,
      {
        id: action.payload.values.id,
      }
    );
    yield put(
      courseMaterialByIdSuccess({
        courseMaterialDetails: response.item,
      })
    );
    action.payload.callback({
      courseMaterialDetails: response.item,
    });
  } catch (e) {
    yield put(
      courseMaterialByIdFailure({
        error: (e as AxiosError).message,
      })
    );
  }
}

function* deleteCourseMaterialSaga(action: DeleteCourseMaterialRequest) {
  try {
    const response: DeleteCourseMaterialResponse = yield call(
      courseService.deleteCourseMaterial,
      {
        id: action.payload.values.id,
      }
    );

    yield put(
      deleteCourseMaterialSuccess({
        success: response.isSuccessStatusCode,
      })
    );
    action.payload.callback({
      success: response.isSuccessStatusCode,
    });
  } catch (e) {
    yield put(
      deleteCourseMaterialFailure({
        error: (e as AxiosError).message,
      })
    );
  }
}

function* scoListByCourseIdSaga(action: GetSCOListByCourseIdRequest) {
  try {
    const payload: ISCOListByCourseIdRequest = {
      sortColumn: action.payload.values.sortColumn,
      sortBy: action.payload.values.sortBy,
      pageNo: action.payload.values.pageNo,
      pageSize: action.payload.values.pageSize,
      courseId: action.payload.values.courseId,
    };
    const response: SCOListByCourseIdResponse = yield call(
      courseService.getSCOListByCourseId,
      payload
    );
    const paginationDetails = {
      nextPage: response.item.nextPage,
      prevPage: response.item.prevPage,
      totalCount: response.item.totalRecordCount,
      totalPages: response.item.pageCount,
    };
    yield put(
      getSCOListByCourseIdSuccess({
        courseOfferingList: response.item.records,
        courseOfferingListPagination: paginationDetails,
      })
    );
    action.payload.callback({
      courseOfferingList: response.item.records,
      courseOfferingListPagination: paginationDetails,
    });
  } catch (e) {
    yield put(
      getSCOListByCourseIdFailure({
        error: (e as AxiosError).message,
      })
    );
  }
}

function* pendingCourseEnrollmentEducatorsSaga(
  action: PendingCourseEnrollmentEducatorsRequest
) {
  try {
    const response: PendingCourseEnrollmentEducatorsResponse = yield call(
      courseService.getPendingCourseEnrollmentEducators,
      action.payload.values
    );

    yield put(
      pendingCourseEnrollmentEducatorsSuccess({
        educators: response.item,
      })
    );
    action.payload.callback(response.item);
  } catch (e) {
    yield put(
      pendingCourseEnrollmentEducatorsFailure({
        error: (e as AxiosError).message,
      })
    );
  }
}

function* courseSaga() {
  yield all([takeLatest(COURSE_LIST_REQUEST, courseListSaga)]);
  yield all([takeLatest(ADD_COURSE_REQUEST, addCourseSaga)]);
  yield all([takeLatest(EDIT_COURSE_REQUEST, editCourseSaga)]);
  yield all([takeLatest(DELETE_COURSE_REQUEST, deleteCourseSaga)]);
  yield all([takeLatest(COURSE_BY_ID_REQUEST, courseByIdSaga)]);
  yield all([takeLatest(COURSE_MATERIAL_LIST_REQUEST, courseMaterialListSaga)]);
  yield all([takeLatest(ADD_COURSE_MATERIAL_REQUEST, addCourseMaterialSaga)]);
  yield all([takeLatest(EDIT_COURSE_MATERIAL_REQUEST, editCourseMaterialSaga)]);
  yield all([
    takeLatest(COURSE_MATERIAL_BY_ID_REQUEST, courseMaterialByIdSaga),
  ]);
  yield all([
    takeLatest(DELETE_COURSE_MATERIAL_REQUEST, deleteCourseMaterialSaga),
  ]);
  yield all([
    takeLatest(GET_SCO_LIST_BY_COURSE_ID_REQUEST, scoListByCourseIdSaga),
  ]);
  yield all([
    takeLatest(
      PENDING_COURSE_ENROLLMENT_EDUCATORS_REQUEST,
      pendingCourseEnrollmentEducatorsSaga
    ),
  ]);
}

export default courseSaga;
